import React from 'react';
// --------------------------------------------------------------------------------
import { Form } from './Form';
import { config } from '../index';

export interface BookingCardProps {
  /* Slider link props */
  links?: LinkProps[];
  /* Slider margin */
  margin?: string;
  /* Slider padding */
  padding?: string;
  /* Slider width */
  maxWidth?: string;
  /* Slider height */
  minHeight?: string;
  /* Slider content height */
  height?: string;
  /* Slider content width */
  width?: string;
  /* Slider background color*/
  backgroundColor?: string;
  /* Slider border */
  border?: string;
  /* Slider border radius */
  borderRadius?: string;
  /* Slider indicator */
  hasIndicator?: boolean;
  /* Slider component gap */
  gap?: string;
  /* Slider additional className props */
  className?: string;
}

interface LinkProps {
  title?: string;
  url?: string;
}

export const BookingCard: React.FC<BookingCardProps> = ({
  /* Input properties */
  links,
  margin,
  padding,
  maxWidth = '1245px',
  minHeight,
  height = '620px',
  width = `calc(1245px * 0.8)`, // 👉 80% of maxWidth
  backgroundColor,
  border = `1px solid ${config.grey}`,
  borderRadius = config.spacingXMedium,
  gap = config.fontXMedium,
  className,
  hasIndicator = true,
  ...props
}) => {
  // --------------------------------------------------------------------------------
  // 📌  From component. Extends Card.tsx
  // --------------------------------------------------------------------------------

  return (
    <Form
      title={[
        {
          string: '$23/day',
          fontSize: '40px',
          padding: 'unset',
          align: 'flex-start',
          width: '50%',
        },
        {
          string: '4.9 (23)',
          fontSize: '40px',
          padding: 'unset',
          align: 'end',
          width: '50%',
        },
      ]}
      input={[
        {
          label: { string: 'Rent from' },
          type: 'date',
          name: 'rentFrom',
          placeholder: 'Enter Username',
          width: '48%',
        },
        {
          label: { string: 'Till' },
          type: 'date',
          name: 'till',
          placeholder: 'Enter Username',
          width: '48%',
        },
      ]}
      button={[
        {
          label: { string: 'Create Account' },
          width: '35%',
          margin: `20px 0`,
          onClick: () => console.log('Create Account'),
        },
      ]}
      body={[
        {
          string: 'You won`t be charged yet',
          fontSize: '20px',
        },
      ]}
      titleConfig={{}}
      inputConfig={{ gap: '2%' }}
      bodyConfig={{ order: 2 }}
      buttonConfig={{ order: 1 }}
      {...props}
    />
  );
};
